import { useLocation } from "react-router-dom";
import { useNavigateWithSameKey } from "../../../../../../../../../../../custom-hooks/navigateWithKey";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import {
  LoadingModalContext,
  MessagePopupContext,
} from "../../../../../../../../../ServicePage";
import {
  setLocatorsState,
  setPageClassState,
} from "../../../../../../../../../../../store/slices/test-automation/web/flow-stages/playwrightCSharpSpecflowSlices";
import LocatorsPage from "../../../../../shared/LocatorsPage";
import { Box, Button } from "@mui/material";
import {
  ArrowBack as BackIcon,
  ArrowForward as NextIcon,
} from "@mui/icons-material";
import { handleProgressBar } from "../../../../../../../../../../custom-components/ProgressBar/ProgressBarWithAPI";
import { pageClassAPI, pageClassAPIWithToolCalling } from "../../../../../../../../../../../services/webServices";

const LocatorsPagePlaywrightCSharpSpecflow = () => {
  const navigate = useNavigateWithSameKey();
  const location = useLocation();
  const dispatch = useDispatch();

  const { locationKey } = location.state;

  const { locators, automationPath } = useSelector(
    (state) =>
      state["testAutomation"][locationKey]["webAutomation"][
        "playwrightCSharpSpecflow"
      ] || {}
  );

  const { setMessage, setMessagePopup } = useContext(MessagePopupContext);
  const { setLoadingState } = useContext(LoadingModalContext);

  useEffect(() => {
    if (!locationKey) {
      navigate("/landingpage");
      return;
    }
  }, [locationKey]);

  const handleLocatorsUpdate = (updatedLocators) => {
    dispatch(setLocatorsState(locationKey, updatedLocators));
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleContinueClick = async () => {
    try {
      let progressHandler = handleProgressBar({
        setLoadingState,
        totalDurationMs: 18000,
      });
      progressHandler.start("Generating Page Classes...");

      // Your API call or processing logic here
      const response = await pageClassAPI(
        locators,
        "playwright-c-sharp"
      );
      dispatch(setPageClassState(locationKey, response.data));

      // Navigate to next step
      navigate(`${automationPath}/page-class`);

      progressHandler.stop();
    } catch (error) {
      setMessage(
        error.response.data.error ||
          "An error occurred while generating the feature file."
      );
      setMessagePopup(true);
    } finally {
      setLoadingState({
        open: false,
        message: "",
        progress: null,
      });
    }
  };

  return (
    <Box sx={{ height: "100%" }}>
      {/* Pass both locators and update handler */}
      <LocatorsPage
        locators={locators}
        onLocatorsUpdate={handleLocatorsUpdate}
      />

      <Box
        sx={{
          p: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "transparent",
          borderRadius: "0 0 8px 8px",
        }}
      >
        {/* Back Button */}
        <Button
          variant="outlined"
          startIcon={<BackIcon />}
          onClick={handleBackClick}
          sx={{
            borderColor: "#0094FB",
            color: "#0094FB",
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "8px",
            borderWidth: "2px",
            paddingTop: "8px",
            paddingRight: "16px",
            paddingBottom: "8px",
            paddingLeft: "16px",
            gap: "8px",
            "&:hover": {
              borderColor: "#0094FB",
              backgroundColor: "rgba(0, 148, 251, 0.04)",
            },
          }}
        >
          Back
        </Button>

        {/* Continue Button */}
        <Button
          variant="contained"
          endIcon={<NextIcon />}
          onClick={handleContinueClick}
          disabled={!locators || locators.length === 0}
          sx={{
            backgroundColor: "#0094FB",
            color: "white",
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "8px",
            borderWidth: "2px",
            borderColor: "#0094FB",
            paddingTop: "8px",
            paddingRight: "16px",
            paddingBottom: "8px",
            paddingLeft: "16px",
            "&:hover": {
              backgroundColor: "#0078D4",
              borderColor: "#0078D4",
            },
          }}
        >
          Generate Page Class
        </Button>
      </Box>
    </Box>
  );
};

export default LocatorsPagePlaywrightCSharpSpecflow;
